<template>
    <div class="e-chart-buttons d-flex justify-content-end">
      <div class="d-flex align-items-center">
        <div v-show="displayDownloadComments" class="form-group form-inline mb-0">
          <button class="btn ml-1" type="button" @click="downloadComments">
            <i class="fa-solid fa-thought-bubble fa-lg" style="color: #2f5eb3;"></i>
            <span class="pl-2">Download Comments</span>
          </button>
        </div>
        <div v-show="displayAngleText" class="form-group form-inline mb-0">
            <input
            type="checkbox"
            class="form-check-input"
            id="angleText"
            name="angleText"
            v-model="angleText"
            @click="changeAngleText($event)"
            />
            <label for="angleText">Angle X-axis Text </label>
        </div>                   
        <div v-show="displayShowRespondents" class="form-group form-inline mb-0">
            <input type="checkbox" 
              id="displayNumberOfResponses" 
              name="displayNumberOfResponses" 
              v-model="displayNumberOfResponses" 
              @click="changeDisplayNumberOfResponses($event)"/>
            <label for="segment" class="control-label pl-1 pr-2">Show Respondents (n=)</label>
        </div>
        <div v-show="displayShowTooltip" class="form-group form-inline mb-0">
            <input type="checkbox" 
              id="showTooltip" 
              name="showTooltip" 
              v-model="showTooltip" 
              @click="changeShowTooltip($event)"/>
            <label for="segment" class="control-label pl-1 pr-1">Show Tooltip</label>
        </div>
        <div  v-show="displaySortBy" class="pl-2">
          <select id="sortBy" name="sortBy" class="custom-select required" v-model="sortBy" @change="setSortBy()">
            <option value>Sort By</option>
            <option v-for="(sort_by_option, idxSortByOptions) in this.inputSortByOptions" :value="sort_by_option.value" :key="idxSortByOptions">
              {{ sort_by_option.name }}
            </option>
          </select>
        </div>
      </div>
      <div v-for="(pageContent, idxPageContent) in pageContentForNPS" v-bind:key="idxPageContent">
        <modal :modal-id="pageContent.title" :modal-title="pageContent.title" :modal-content="pageContent.contentText" />
      </div>      
    </div>
</template>

<script>
import EChartsButtonsMixins from '../../mixins/EChartsButtonsMixins.vue';
import Modal from "../Modal.vue";
import ContentService from '../../services/content.service';
export default {
  name: "ProfileChartButtons",
  mixins: [EChartsButtonsMixins],
  components: {Modal},
  data() {
    return {
      showGoalLine: true,
      angleText: true,
      displayNumberOfResponses: false,
      showTooltip: true,
      pageContentForNPS: [],
      sortBy: "valueGap",
    };
  },
  props: {
    inputSortByOptions: {
      type: Array,
      default: function() {
        return [
          { name: "Willingness to Pay", value: "willingnessToPay" },
          { name: "Value Gap", value: "valueGap" },
        ];
      }
    },
    inputShowGoalLine: {
        type: Boolean,
        default: true
    },       
    inputSortBy: {
        type: String,
        default: ""
    },
    inputAngleText: {
        type: Boolean,
        default: true
    },   
    inputDisplayNumberOfResponses: {
        type: Boolean,
        default: true
    },   
    displayShowRespondents: {
        type: Boolean,
        default: true
    },
    displayShowTooltip: {
        type: Boolean,
        default: true
    },
    inputShowTooltip: {
        type: Boolean,
        default: true
    },
    displaySortBy: {
        type: Boolean,
        default: false
    },
    displayDownloadComments: {
        type: Boolean,
        default: true
    }
  },
  computed: {
    displayAngleText: function(){
        //return this.eChartType == "stacked-bar-vertical";
        return false;
    },
  },
  mounted() {
    this.setChart(this.inputEChartType, this.getChartIndex(this.inputEChartType,this.inputRecalculate), this.inputRecalculate);      
    this.displayNumberOfResponses = this.inputDisplayNumberOfResponses;
    this.showTooltip = this.inputShowTooltip;
    this.sortBy = this.inputSortBy;
  },
  created() {
    ContentService.getPageContent("NPS", this.getPageContentByNPSCallBack, this);    
  },
  methods: {
    downloadComments: function(){
      this.$emit("download-comments", true);
    },
    getPageContentByNPSCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForNPS = response.data.data;
      }
    },      
    changeShowTooltip: function(event) {
        this.showTooltip = event.target.checked;
        this.$emit("set-show-tooltip", this.showTooltip);
    },    
    changeDisplayNumberOfResponses: function(event) {
        this.displayNumberOfResponses = event.target.checked;
        this.$emit("set-display-number-of-responses", this.displayNumberOfResponses);
    },    
    setSortBy: function(){
        this.$emit("set-sort-by", this.sortBy);
    },
    changeAngleText: function(event) {
        this.angleText = event.target.checked;
        this.$emit("set-angle-text", this.angleText);
    },
    getClass:function(index){
        return this.chartSelected == index ? "selected" : "";
    },
    verifyChartCriteria: function(eChartType){
        let verified = true;
        return verified;
    },
  },
  watch: {
    inputSortBy: function(){
      if (this.inputSortBy != ""){
        this.sortBy = this.inputSortBy;
      }
    },
    inputAngleText: function(){
        this.angleText = this.inputAngleText;
    },
    inputShowGoalLine: function(){
        this.showGoalLine = this.inputShowGoalLine;
    },
    inputDisplayNumberOfResponses: function(){
        this.displayNumberOfResponses = this.inputDisplayNumberOfResponses;
    },
    inputinputShowTooltip: function(){
        this.showTooltip = this.inputShowTooltip;
    },
  },
};
</script>
